import styled from '@emotion/styled';
import React, { ReactElement } from 'react';
import { OL_COLOUR_KELP } from '../../../components/Style/colours';
import { BillingDetailsTable } from '../../../components/SubscriptionsHelper/BillingDetailsTable/component';
import { UserSubscriptionPlanDetail } from '../types';

const Heading = styled('div')({
  fontSize: 18,
  borderBottom: '1px solid #CACACA',
  fontWeight: 600,
  lineHeight: '35px',
  marginBottom: 20,
});

const BillingDetailsContainer = styled('div')({
  marginTop: 20,
});

const ContactUsContainer = styled('div')({
  textAlign: 'center',
  fontWeight: 600,
  fontSize: 16,
  marginTop: 24,
});

const StyledContactUs = styled('a')({
  color: OL_COLOUR_KELP,
});

interface BillingDetailsProps {
  isOwner: boolean;
  UsageLimitExceededBanner: JSX.Element | null;
  plan: UserSubscriptionPlanDetail;
  actions: ReactElement[];
}

export const BillingDetails = React.memo(
  ({
    isOwner,
    plan,
    UsageLimitExceededBanner,
    actions,
  }: BillingDetailsProps) => (
    <div>
      <Heading>Billing details</Heading>
      {UsageLimitExceededBanner}
      <BillingDetailsContainer>
        <BillingDetailsTable isOwner={isOwner} plan={plan} actions={actions} />
      </BillingDetailsContainer>
      <ContactUsContainer>
        Have a question about your subscription plan?{' '}
        <StyledContactUs
          href="https://solutions.openlearning.com/contact"
          target="_blank"
        >
          Contact us
        </StyledContactUs>
      </ContactUsContainer>
    </div>
  )
);
